import React, { useState } from 'react';

import DataGrid, { Column, Editing, MasterDetail } from 'devextreme-react/data-grid';

import { withLoadPanel } from '../../../utils/withLoadPanel';


import './CardEvents.scss';
import { GENDERS } from '../../../shared/constants';
import { checkPermission } from '../../../permissions';
import { EventDetails } from '../event-details/EventDetails';


const Grid = ({ events, sessions, swimstyles, competitionId }) => {
    const [gridData] = useState(events);
    const handleInitNewRow = (e) => {
        e.data.competitionId = competitionId;
      };
    
    return (
        <DataGrid
            className='events-grid'
            dataSource={gridData}
            remoteOperations={true}
            columnAutoWidth
            height={'calc(100vh - 210px)'}
            onInitNewRow={handleInitNewRow}
        >
             <Editing allowUpdating={checkPermission("competition.edit")} allowAdding={checkPermission("competition.edit")} allowDeleting={checkPermission("competition.edit")} />
             <MasterDetail
                enabled={true}
                component={EventDetails}
            />

                        <Column
                dataField='number'
                caption='Wettkampf-Nr'
                
            />
            <Column
                dataField='sessionId'
                caption='Abschnitt'
                lookup={{
                    dataSource: sessions,
                    valueExpr: 'sessionId',
                    displayExpr: 'name'
                }}
            />
             <Column
                dataField='swimstyleId'
                caption='Strecke'
                hidingPriority={3}
                lookup={{
                    dataSource: swimstyles,
                    valueExpr: 'swimstyleId',
                    displayExpr: 'name'
                }}
            />
            <Column
                dataField='gender'
                caption='Gender'
                lookup={{
                    dataSource: GENDERS,
                     valueExpr: 'id',
                    displayExpr: 'text'
                }}
            />

            <Column
                dataField='eventorder'
                caption='Event Order'
             
                sortOrder='asc'
                sortIndex={0}
                visible={false}
            />

            <Column
                dataField='round'
                caption='Round'
                
            />

            <Column
                dataField='details'
                dataType=''
                caption='Details'
              
            />

        </DataGrid>
    );
};

const GridWithLoadPanel = withLoadPanel(Grid);

export const CardEvents = ({ events, sessions, swimstyles, isLoading, competitionId }) => {
    return (
        <div className='card-events'>
            <GridWithLoadPanel
                events={events}
                sessions={sessions}
                swimstyles={swimstyles}
                hasData={!!events}
                loading={isLoading}
                competitionId={competitionId}            
                    panelProps={{
                    container: '.card-events',
                    position: { of: '.card-events' }
                }}
            />
        </div>
    );
};
